const bg = {
  // App
  appName: "Система за отчети",
  appSubtitle: "СЗДП",
  appDescription: "СЗДП",

  // Auth
  signIn: "Вход",
  signingIn: "Влизане...",
  email: "Имейл",
  password: "Парола",
  logout: "Изход",
  loginFailed: "Неуспешен вход",
  invalidCredentials: "Невалидни данни за достъп",
  demoAdmin: "Демо: admin@szdp.bg / admin123",
  demoUnit: "Звено: user@dgs-ber.bg / user123",

  // Navigation
  dashboard: "Табло",
  templates: "Шаблони",
  admin: "Администрация",
  periods: "Отчетни периоди",

  // Dashboard
  centralOverview: "Обзор на Централно управление",
  unitReports: "Справки на",
  totalReports: "Общо справки",
  draft: "Чернова",
  submitted: "Подаден",
  approved: "Одобрен",
  locked: "Заключен",
  templatesCount: "Шаблони",
  unitsCount: "Звена",
  periodsCount: "Периоди",
  lockedCount: "Заключени",
  reportInstances: "Справки по звена",
  filterByPeriod: "Филтрирай по период",
  allPeriods: "Всички периоди",
  noInstances: "Не са намерени справки.",
  noInstancesAdmin: " Качете шаблон и публикувайте.",
  open: "Отвори",
  approve: "Одобри",
  reopen: "Отвори отново",
  exportAll: "Експорт на всички",
  consolidatedSummary: "Обобщена справка",
  revenue: "Приходи",
  expenses: "Разходи",
  result: "Резултат",
  issues: "Проблеми",
  unit: "Звено",
  status: "Статус",
  template: "Шаблон",
  period: "Период",
  actions: "Действия",

  // Report Editor
  back: "Назад",
  saving: "Запазване...",
  editable: "редактируеми",
  formulas: "формули",
  validate: "Валидирай",
  audit: "Одит",
  auditTrail: "Одитна пътека",
  noChanges: "Няма записани промени",
  validationResults: "Резултати от валидацията",
  export: "Експорт",
  submit: "Подай",
  reject: "Отхвърли",
  lock: "Заключи",
  editableInput: "Редактируемо поле",
  formulaAutoCalc: "Формула (авт.)",
  protectedPreset: "Защитена стойност",
  static: "Статично",
  noData: "Няма данни за този лист",
  reportSubmitted: "Справката е подадена",
  reportApproved: "Справката е одобрена",
  reportLocked: "Справката е заключена",
  reportReopened: "Справката е отворена за редакция",
  reportRejected: "Справката е върната за корекция",
  protectedCell: "Защитена клетка",
  downloaded: "Изтеглено",

  // Workflow statuses (Bulgarian)
  needsCorrection: "За корекция",
  awaitingSubmission: "Очаква да бъде подадено",
  correctionNote: "Бележка за корекция",
  requestCorrection: "Коригирай",
  correctionNoteLabel: "Бележка към звеното",
  correctionNotePlaceholder: "Опишете какво трябва да се коригира...",
  correctionRequested: "Справката е върната за корекция",
  adminEditMode: "Редакция",
  adminEditModeActive: "Режим редакция (админ)",
  adminOverride: "Админ корекция",
  unlockCell: "Отключи клетка",
  lockCell: "Заключи клетка",
  cellUnlocked: "Клетката е отключена",
  cellLocked: "Клетката е заключена",
  adminOverriddenCell: "Коригирано от админ",
  cellValue: "Стойност",
  formulaLabel: "Формула",
  formulaHint: "Оставете празно за премахване. Пр.: =SUM(D10:D14) или =ЗВЕНО(\"КОД\",\"лист\",\"клетка\") или =ЗВЕНО(\"КОД\",\"лист\",\"клетка\",\"шаблон\")",
  writableForUnit: "Редактируема за звеното",
  consolidatedReport: "Цялостен отчет",
  consolidatedReportDesc: "Обобщени данни от всички звена",
  unitsIncluded: "Включени звена",
  formulaLockedWarning: "Формулата е заключена и не препоръчваме промени по тях. Сигурни ли сте, че искате да продължите?",
  unlockFormula: "Отключи формулата",
  formulaUnlocked: "Формулата е отключена за редакция",
  sumFromUnits: "Сума от звена",
  recalcFromFormula: "Преизчислено по формула",
  toggleRecalc: "Превключи: сума/формула",
  consolidatedSettings: "Настройки на консолидиран отчет",
  recalcCellsSaved: "Настройките са записани",
  sumMode: "Сума",
  formulaMode: "Формула",
  rowVisibility: "Видимост на редове",
  rowVisibilityDesc: "Задайте кое звено вижда всеки ред",
  rowVisibilityMode: "Видимост по ред",
  assignUnit: "Присвои звено",
  allUnits: "Всички звена",
  rowAssigned: "Редът е присвоен",
  rowVisibilitySaved: "Видимостта е записана",
  templateEditor: "Редактор на шаблон",
  templateEditorDesc: "Редактирайте стойности, формули и добавяйте редове",
  editTemplate: "Редактирай шаблон",
  addRows: "Добави редове",
  rowsAdded: "Редовете са добавени",
  cellSaved: "Клетката е запазена",
  recalculate: "Рекалкулирай",
  recalculating: "Рекалкулиране...",
  recalculated: "Рекалкулирано",
  bulkRecalculate: "Масово рекалкулиране",
  bulkRecalculating: "Рекалкулиране... ({progress})",
  bulkRecalculated: "Масово рекалкулиране завършено: {count} отчета, {updates} обновени клетки",
  bulkRecalcDesc: "Изпълнява множество проходи на рекалкулиране за всички отчети в периода. Полезно за възстановяване на формулни данни.",
  cellsRecalculated: "формули преизчислени",
  editDeadline: "Промени краен срок",
  deadlineSaved: "Крайният срок е записан",
  bulkDeadline: "Краен срок за всички",
  bulkDeadlineDesc: "Промяна на крайния срок за всички отчети в избрания период",
  bulkDeadlineUpdated: "Крайният срок е обновен за всички отчети",
  emailSent: "Имейл изпратен",
  director: "Директор",
  accountant: "Счетоводител",
  directorPlaceholder: "Име на директор",
  accountantPlaceholder: "Име на счетоводител",

  // Templates
  templateManager: "Управление на шаблони",
  templateManagerDesc: "Качване, преглед и публикуване на шаблони",
  uploadTemplate: "Качи шаблон",
  newPeriod: "Нов период",
  createPeriod: "Създай отчетен период",
  periodName: "Наименование на период",
  year: "Година",
  createPeriodBtn: "Създай период",
  reportingPeriods: "Отчетни периоди",
  reportingPeriodsDesc: "Управление на тримесечни, полугодишни и годишни периоди",
  noTemplates: "Няма качени шаблони",
  noTemplatesDesc: "Качете .xlsx шаблон, за да започнете",
  sheets: "Листове",
  cells: "Клетки",
  editableCount: "Редактируеми",
  formulasCount: "Формули",
  preview: "Преглед",
  publish: "Публикувай",
  publishToUnits: "Публикувай към звена",
  selectPeriod: "Изберете отчетен период",
  choosePeriod: "Изберете период",
  publishInfo: "Това ще създаде справки за всички {count} звена.",
  publishToAll: "Публикувай към всички звена",
  deadline: "Краен срок",
  deadlinePlaceholder: "Изберете краен срок",
  deadlineExpired: "Срокът е изтекъл",
  deadlineSoon: "Остават дни",
  daysLeft: "дни",
  templatePreview: "Преглед на шаблон",
  close: "Затвори",
  rows: "Редове",
  cols: "Колони",
  merged: "Обединени",

  // Admin
  administration: "Администрация",
  adminDesc: "Управление на звена, потребители и карта на входни данни",
  unitsTab: "Звена",
  usersTab: "Потребители",
  inputMapTab: "Карта на данни",
  visualEditorTab: "Визуален редактор",
  territorialUnits: "Териториални звена",
  addUnit: "Добави звено",
  addNewUnit: "Ново звено",
  unitName: "Наименование",
  unitCode: "Код на звено",
  hasUser: "Има потребител",
  yes: "Да",
  no: "Не",
  create: "Създай",
  systemUsers: "Системни потребители",
  bulkProvision: "Масово създаване",
  bulkProvisionTitle: "Масово създаване на потребители",
  bulkProvisionDesc: "Създаване на потребителски акаунт за всяко звено без такъв. Парола по подразбиране:",
  unitsWithoutUsers: "Звена без потребители",
  createAll: "Създай всички",
  addUser: "Добави потребител",
  addNewUser: "Нов потребител",
  name: "Име",
  role: "Роля",
  centralAdmin: "Централен администратор",
  unitUser: "Потребител на звено",
  assignedUnit: "Присвоено звено",
  selectUnit: "Изберете звено",
  active: "Активен",
  disabled: "Деактивиран",
  resetPassword: "Нулиране на парола",
  enterNewPassword: "Въведете нова парола (мин. 6 символа):",
  deactivate: "Деактивирай",
  activate: "Активирай",
  delete: "Изтрий",
  deleteConfirm: "Изтриване на този потребител?",
  userCreated: "Потребителят е създаден",
  unitCreated: "Звеното е създадено",
  passwordReset: "Паролата е нулирана",
  userDeactivated: "Потребителят е деактивиран",
  userActivated: "Потребителят е активиран",
  userDeleted: "Потребителят е изтрит",

  // Input Map
  inputMap: "Карта на входни данни",
  inputMapDesc: "Определете кои клетки са редактируеми за всеки шаблон.",
  selectTemplate: "Изберете шаблон",
  chooseTemplate: "Изберете шаблон",
  inputMapJson: "JSON на картата",
  saveInputMap: "Запази картата",
  inputMapSaved: "Картата е запазена.",
  editableCells: "редактируеми клетки",
  invalidJson: "Невалиден JSON",
  saveFailed: "Грешка при запис",

  // Visual Editor
  visualEditor: "Визуален редактор",
  visualEditorDesc: "Кликнете или маркирайте клетки, за да ги зададете като РАЗРЕШЕНИ или ЗАБРАНЕНИ",
  doubleClickToEdit: "Двоен клик за редакция на стойност/формула",
  deleteCell: "Изтрий клетка",
  cellDeleted: "Клетката е изтрита",
  publishCellChanges: "Публикувай промените",
  publishingChanges: "Публикуване на промените...",
  cellChangesPublished: "Промените са публикувани към отчетите",
  allow: "Разреши",
  deny: "Забрани",
  clear: "Изчисти",
  allowed: "Разрешено",
  denied: "Забранено",
  formula: "Формула",
  deniedSheet: "Забранен лист",
  selectSheet: "Изберете лист",
  applyToInstances: "Приложи към справките",
  applyToInstancesDesc: "Приложи промените в картата към съществуващи справки (Чернова/Подаден)",
  applySuccess: "Картата е приложена успешно към {count} справки",
  version: "Версия",
  saved: "Запазено",
  noChangesDetected: "Не са открити промени",
  loading: "Зареждане...",
  save: "Запази",
  
  // Template Delete / Lifecycle
  deleteTemplate: "Изтрий шаблон",
  deleteTemplateConfirm: "Изтриване на този шаблон?",
  deleteTemplateHasInstances: "Този шаблон има съществуващи отчети. Ще бъде архивиран и няма да може да се публикува отново, но старите отчети ще останат достъпни.",
  deleteTemplateNoInstances: "Шаблонът ще бъде архивиран.",
  templateDeleted: "Шаблонът е архивиран.",
  archived: "Архивиран",
  showArchived: "Покажи архивирани",
  hideArchived: "Скрий архивирани",

  // Deletion Status Tabs
  activeTab: "Активни",
  archivedTab: "Архивирани",
  trashTab: "Кошче",
  archive: "Архивирай",
  restore: "Възстанови",
  moveToTrash: "В кошчето",
  restoreFromTrash: "Възстанови от кошче",
  permanentDelete: "Изтрий завинаги",
  permanentDeleteConfirm: "Перманентно изтриване",
  permanentDeleteWarning: "Това действие е необратимо! Всички данни ще бъдат изтрити завинаги.",
  typeDeleteConfirm: "Въведете DELETE за потвърждение:",
  templateArchived: "Шаблонът е архивиран",
  templateRestored: "Шаблонът е възстановен",
  templateTrashed: "Шаблонът е преместен в кошчето",
  templateUntrashedToArchive: "Шаблонът е възстановен в архива",
  templatePermanentlyDeleted: "Шаблонът е изтрит завинаги",
  unitArchived: "Звеното е архивирано",
  unitRestored: "Звеното е възстановено",
  unitTrashed: "Звеното е преместено в кошчето",
  unitUntrashedToArchive: "Звеното е възстановено в архива",
  unitPermanentlyDeleted: "Звеното е изтрито завинаги",
  deletionBlocked: "Изтриването е блокирано поради зависимости",
  noArchivedTemplates: "Няма архивирани шаблони",
  noTrashedTemplates: "Кошчето е празно",
  noArchivedUnits: "Няма архивирани звена",
  noTrashedUnits: "Кошчето е празно",

  // Formula Analysis
  formulaAnalysis: "Анализ на формули",
  formulaCheck: "Проверка на формулите",
  formulaCheckDesc: "Валидация на формулите в шаблона",
  supportedFormulas: "Поддържани формули",
  unsupportedFormulas: "Неподдържани формули",
  formulaIssues: "Формули с проблеми",
  formulaIssuesDesc: "Формули, които не се изчисляват",
  totalFormulas: "Общо формули",
  evaluable: "Изчислими",
  errors: "Грешки",
  functionCounts: "Функции",
  supportedList: "Поддържани: SUM, IF, ROUND, ROUNDUP, ROUNDDOWN, MIN, MAX, ABS, COUNTA, IFERROR, AVERAGE, COUNT, AND, OR, NOT, INT, MOD, CONCATENATE, LEN, LEFT, RIGHT, MID, TRIM, UPPER, LOWER, VALUE, TEXT, SUMIF, COUNTIF, ЗВЕНО",
  noIssues: "Няма проблеми с формулите",
  scanTemplate: "Сканирай формули",
  runValidation: "Стартирай проверка",
  validationRunning: "Проверка...",
  validationPassed: "Проверката мина успешно",
  validationFailed: "Открити са проблеми",
  goldenCells: "Златни клетки",
  goldenCellsPassed: "преминали",
  goldenCellsFailed: "неуспешни",
  externalRefs: "Външни референции",
  brokenRefs: "Счупени референции",
  formulaTypes: "Видове формули",
  lastValidation: "Последна проверка",

  // Period Types
  periodType: "Тип на период",
  quarter: "Тримесечие",
  halfYear: "Полугодие",
  yearly: "Годишен",
  periodIndex: "Номер",
  quarterI: "I тримесечие",
  quarterII: "II тримесечие",
  quarterIII: "III тримесечие",
  quarterIV: "IV тримесечие",
  halfI: "I полугодие",
  halfII: "II полугодие",
  periodCreated: "Периодът е създаден",
  periodExists: "Такъв период вече съществува",
  periodDeleted: "Периодът е изтрит",
  periodDeleteBlocked: "Периодът не може да бъде изтрит",
  noPeriods: "Няма създадени периоди",
  noPeriodsDesc: "Създайте отчетен период, за да започнете",
  deletePeriod: "Изтрий период",
  deletePeriodConfirm: "Изтриване на този период?",

  // Publish Input Map
  publishedSuccess: "Публикувано успешно",
  publishWarning: "Публикуване",
  affectedInstances: "Засегнати отчети",
  unlockedCells: "Отключени клетки",
  lockedCells: "Заключени клетки",
  totalEditable: "Общо редактируеми",
  versionLabel: "Версия",
  noInstancesWarning: "Няма отчети за този шаблон",
  noDraftSubmittedWarning: "Няма чернови/подадени отчети",

  // Changelog
  changelog: "Промени лог",
  changelogDesc: "История на промените",
  versionHistory: "Версии на картата",
  changesBetween: "Промени между",
  and: "и",
  added: "Добавени",
  removed: "Премахнати",
  noVersions: "Няма записани версии",
  viewDiff: "Сравни",
  change: "Промяна",
  before: "Преди",
  after: "След",
  user: "Потребител",
  sheet: "Лист",
  cell: "Клетка",
  date: "Дата",
  allSheets: "Всички листове",
  allUsers: "Всички потребители",
  searchCell: "Търси клетка...",
  cellChanges: "Промени в клетки",
  workflowChanges: "Действия по статус",
  noLogs: "Няма записани промени",

  // Units Admin
  editUnit: "Редактирай звено",
  deactivateUnit: "Деактивирай звено",
  activateUnit: "Активирай звено",
  reassignUsers: "Преназначи потребители",
  reassignUsersDesc: "Преназначи потребителите към друго звено:",
  targetUnit: "Целево звено",
  deactivateUsersOption: "Деактивирай потребителите",
  reassignOption: "Преназначи към:",
  deactivateUnitConfirm: "При деактивиране на звеното, всички потребители ще бъдат деактивирани. Съществуващите отчети остават достъпни за ЦУ.",
  unitDeactivated: "Звеното е деактивирано",
  unitActivated: "Звеното е активирано",
  unitUpdated: "Звеното е обновено",
  usersReassigned: "Потребителите са преназначени",
  userCount: "Потребители",
  instanceCount: "Отчети",
  deactivated: "Деактивирано",

  // Errors
  failed: "Грешка",
  loadFailed: "Неуспешно зареждане",
  exportFailed: "Грешка при експорт",
  adminOnly: "Само за администратори.",

  // Unit Settings
  unitSettings: "Настройки на звеното",
  directorName: "Име на директор",
  accountantName: "Име на счетоводител",
  unitSettingsSaved: "Настройките на звеното са запазени",
  unitSettingsDesc: "Тук можете да зададете имената на директора и счетоводителя. Те ще се попълват автоматично в отчетите чрез тагове {ДИРЕКТОР} и {СЧЕТОВОДИТЕЛ}.",

  // Consolidated report
  noSumSkipped: "Без сумиране",

  // Tags
  insertTag: "Вмъкни таг",

  // Font styling
  fontWeight: "Дебелина",
  fontSize: "Размер",
  textAlign: "Подравняване",

  // Merge cells
  mergeCells: "Обединяване",
  merge: "Обедини",
  mergedRanges: "Обединени:",
  clickToUnmerge: "Клик за разделяне",
  cellsMerged: "Клетки обединени",
  cellsUnmerged: "Клетки разделени",
  mergedTotal: "обединявания",

  // Template download
  downloadTemplate: "Изтегли шаблон",

  // Print
  print: "Печат",

  // Consolidated editing
  consolidatedOnly: "само за консолидиран",
  removeOverride: "Премахни промяна",
  overrideRemoved: "Промяната е премахната",

  // Instructions
  instructions: "Инструкции",
  instructionsSubtitle: "Ръководство за работа със системата",
  editInstructions: "Редактирай",
  instructionsSaved: "Инструкциите са запазени",
  markdownHint: "Използвайте # за заглавие, ## за подзаглавие, - за списък, **текст** за удебелен",
  cancel: "Отказ",

  // Template duplicate
  duplicateTemplate: "Дублирай",
  duplicateDesc: "Създаване на копие на шаблон",
  newName: "Ново име",
  duplicate: "Дублирай",
  templateDuplicated: "Шаблонът е дублиран",

  // Find & Replace
  findReplace: "Търси и замени",
  find: "Търси",
  replaceWith: "Замени с",
  replaceAll: "Замени всички",
  findPlaceholder: "текст за търсене...",
  replacePlaceholder: "нов текст...",
  matchCase: "Точно съвпадение",
  replacementsMade: "замени направени",
  noMatchesFound: "Няма намерени съвпадения",
  inSheet: "В лист",
  allSheets: "Всички листове",

  // Profile & Password
  myProfile: "Моят профил",
  fullName: "Пълно име",
  changePassword: "Смяна на парола",
  currentPassword: "Текуща парола",
  newPassword: "Нова парола",
  confirmPassword: "Потвърди парола",
  passwordChanged: "Паролата е сменена успешно",
  passwordMismatch: "Паролите не съвпадат",
  passwordTooShort: "Паролата трябва да е поне 4 символа",
  profileSaved: "Профилът е запазен",

  // Maintenance mode
  maintenanceMode: "Режим поддръжка",
  maintenanceModeDesc: "Когато е активен, потребителите на звена НЕ могат да редактират или подават отчети",
  maintenanceModeActive: "Системата е в режим на поддръжка. Редакцията е временно спряна.",
  maintenanceMessagePlaceholder: "Съобщение за потребителите...",
  enableMaintenance: "Включи поддръжка",
  disableMaintenance: "Изключи поддръжка",
  maintenanceEnabled: "Режим поддръжка е ВКЛЮЧЕН",
  maintenanceDisabled: "Режим поддръжка е ИЗКЛЮЧЕН",
};

export default bg;

export function t(key) {
  return bg[key] || key;
}
